import { render, staticRenderFns } from "./SettingsAttachmentsFolder.vue?vue&type=template&id=6f567b64&scoped=true"
import script from "./SettingsAttachmentsFolder.vue?vue&type=script&lang=js"
export * from "./SettingsAttachmentsFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f567b64",
  null
  
)

export default component.exports